import { Flex, Input, Space, Typography } from 'antd'
import { UserAvatar } from '../../user/components/user-avatar'
import { TimeAgo } from '../../components/time-ago'
import React, { useState } from 'react'
import { Comment as CommentType } from '../comment'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../auth'
import clsx from 'clsx'

export function Comment({ comment }: { comment: CommentType }) {
    const { t } = useTranslation()
    const [editing, setEditing] = useState(false)
    const { user } = useAuth()

    return (
        <Flex
            align="start"
            key={comment.id}
            style={{
                marginLeft: -3,
            }}
            vertical
        >
            <Space>
                <UserAvatar user={comment.user} />
                {comment.user.name}
                <Typography.Text type="secondary">
                    <TimeAgo date={comment.createdAt} />
                </Typography.Text>
            </Space>
            <div className="pl-9">
                <div className={clsx('bg-surface-sunken rounded-xl', { 'p-4': !editing, 'p-[11px]': editing })}>
                    {editing ? (
                        <Input.TextArea
                            defaultValue={comment.content}
                            autoSize
                        />
                    ) : (
                        <Typography.Text>{comment.content}</Typography.Text>
                    )}
                </div>
                {/* @todo finish allowing users to edit comments*/}
                {window.navigator.userAgent === 'no-op' && (
                    <Flex
                        className="mt-1"
                        gap="small"
                    >
                        {editing ? (
                            <>
                                <Typography.Text
                                    type="secondary"
                                    className="block cursor-pointer"
                                    onClick={() => {
                                        setEditing(true)
                                    }}
                                >
                                    {t('Save')}
                                </Typography.Text>
                                <Typography.Text
                                    type="secondary"
                                    className="block cursor-pointer"
                                    onClick={() => {
                                        setEditing(false)
                                    }}
                                >
                                    {t('Cancel')}
                                </Typography.Text>
                            </>
                        ) : (
                            <>
                                {user?.id === comment.user.id && (
                                    <Typography.Text
                                        type="secondary"
                                        className="block cursor-pointer"
                                        onClick={() => {
                                            setEditing(true)
                                        }}
                                    >
                                        {t('Edit')}
                                    </Typography.Text>
                                )}
                            </>
                        )}
                    </Flex>
                )}
            </div>
        </Flex>
    )
}
